import { OshiraseData } from "@/types/Oshirase";
import { reactive, Ref, ref } from "vue";

/*
 * 初期処理
 */
export function useInit() {
    const OshiraseList: Ref<OshiraseData[]> = ref([]);

    return {
        OshiraseList
    }
}
